import { useState } from "react";

import { Observation } from "@medplum/fhirtypes";

import { Anchor, Table, Text, Tooltip } from "@mantine/core";

import PostpartumFlowsheetEditRow from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/PostpartumTable/PostpartumFlowsheetEditRow";

interface PostpartumTimeCellProps extends React.ComponentProps<typeof Table.Td> {
  time: string | undefined;
  rowSpan: number;
  observation?: Observation;
  onRefresh?: () => Promise<void>;
  flowsheetId?: string;
  isViewOnly?: boolean;
}

export default function PostpartumTimeCell({
  time,
  rowSpan,
  flowsheetId,
  observation,
  onRefresh,
  isViewOnly = false,
  ...props
}: PostpartumTimeCellProps) {
  const [showEditDrawer, setShowEditDrawer] = useState(false);

  const handleClick = () => {
    if (isViewOnly) return;
    setShowEditDrawer(true);
  };

  const handleClose = () => {
    setShowEditDrawer(false);
  };

  return (
    <Table.Td fw="bold" miw={100} ta="center" c="burgundy.9" rowSpan={rowSpan} {...props}>
      {isViewOnly ? (
        <Text>{time}</Text>
      ) : (
        <Tooltip label="Edit Row" aria-label="Edit Row">
          <Anchor href={`#${time}`} onClick={handleClick}>
            {time}
          </Anchor>
        </Tooltip>
      )}
      {showEditDrawer && observation && (
        <PostpartumFlowsheetEditRow
          onClose={handleClose}
          onRefresh={onRefresh}
          observation={observation}
          flowsheetId={flowsheetId}
        />
      )}
    </Table.Td>
  );
}
